import React, { Component } from 'react';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import { MagnifyingGlassIcon, BanknotesIcon, PencilIcon, DocumentIcon, ArrowDownIcon, FunnelIcon, ChevronDownIcon, ChevronUpIcon, CalendarIcon, Bars3Icon, Cog6ToothIcon  } from '@heroicons/react/20/solid';
import Breadcrumb from '../../Shared/BreadCumb';
import { getAllPenalities , penalitieStatus, updateData, savePaymentMultiple } from './services/penalities';
import { round2, sumRemainder, refreshSelection, buildDetailFinePayload, collectDetailIds } from '../../Shared/functions';
import { registerAdminPayment } from '../paymentValidation/services/payments';
import ClipLoader from "react-spinners/ClipLoader";
import NoAccesComponent from '../../Shared/NoAccesComponent';
import ResponsiveTable from '../../Shared/ResponsiveTable';
import UserFormModal from './userForm';

import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';

class PenalitiesList extends Component {

    paymentTypes = [
        { value: "3", label: "Pago Móvil" },
        { value: "5", label: "Pago Móvil Directo" }
    ];

    BreadcrumbPages = [ 
        { name: 'Multas', href: '#', current: false },
        { name: 'Lista de multas', href: '#', current: true },
    ]
    userCanEdit = false;
    columns = [
        {field:'fullnameUser', headerName: 'Nombre completo'},
        {field:'identificationUser', headerName: 'Identificación'},
        {field:'code', headerName: 'Código de la Multa'},
        {field:'dateReg', headerName: 'Fecha de registro'},
        {field:'descripStatus', headerName: 'Estatus'},
        {field:'numberPlate', headerName: 'Placa'},
        {field:'totalBS', headerName: 'Monto'},
        {field:'remainder', headerName: 'Restante'},
    ];

    bankAccounts = [
        { value: "0102", label: "Banco de Venezuela, S.A.C.A." },
        { value: "0104", label: "Venezolano de Crédito" },
        { value: "0105", label: "Mercantil" },
        { value: "0108", label: "Provincial" },
        { value: "0114", label: "Bancaribe" },
        { value: "0115", label: "Exterior" },
        { value: "0116", label: "Occidental de Descuento" },
        { value: "0128", label: "Banco Caroní" },
        { value: "0134", label: "Banesco" },
        { value: "0138", label: "Banco Plaza" },
        { value: "0137", label: "Banco Sofitasa" },
        { value: "0146", label: "Bangente" },
        { value: "0151", label: "BFC Banco Fondo Común" },
        { value: "0156", label: "100% Banco" },
        { value: "0157", label: "Del Sur" },
        { value: "0163", label: "Banco del Tesoro" },
        { value: "0166", label: "Banco Agrícola de Venezuela" },
        { value: "0168", label: "Bancrecer" },
        { value: "0169", label: "Mi Banco" },
        { value: "0172", label: "Bancamiga" },
        { value: "0174", label: "Banplus" },
        { value: "0175", label: "Banco Digital de los Trabajadores,Banco Universal" },
        { value: "0177", label: "Banfanb" },
        { value: "0191", label: "BNC Nacional de Crédito" },
        { value: "0171", label: "Banco Activo" },
    ];

    banckReceived = [
        { value: "0102", label: "Banco de Venezuela, S.A.C.A." },
        { value: "0172", label: "Bancamiga" },
        { value: "0191", label: "BNC Nacional de Crédito" }
    ];




    constructor(props) {
        super(props)
        this.state = {
            loading:false,
            identification:'',
            numberPlate:'',
            dateEnd:'',
            dateStart:'' ,
            penalities:[],
            detailPenalitie:false,
            penalitie:null,
            changeStatus:false,
            status:-1,
            loadingForm:false,
            payment:false,
            paymentMultiple:false,
            limit:100,

            paymentType:'',
            paymentCost:'',
            paymentRef: '',
            paymentBank: '',
            paymentComment: '',
            paymentVoucher: '',
            paymentVoucherName: '',

            name: '',
            identificationPayment:'',
            phone: '',
            bankCode: '',
            bank: '',
            account:'',
            dateTrans: new Date().toISOString().slice(0, 10),
            bankCodeReceiving:'',
            bankReceiving:'',


            canExonere: false,
            canCreate: false,
            canEdit: false,
            canSee: false,
            canUpdateStatus: false,
            limitReport: 100,

            tabs: [
                {name: 'Detalles de la Persona', href:'#', current:true, id:0},
                {name: 'Detalles de la Multa', href:'#', current:false, id:1},
                {name: 'Detalles de pago', href:'#', current:false, id:2}
            ],

            // UI state
            isFiltersOpen: true,
            openMenuId: null, 
            menuAnchorEl: null,     

            changeData: false,

            // Estado del diálogo "Actualizar estado". Separado de `status`
            // (filtro de búsqueda) para que cambiar el estado de una multa
            // no re-filtre la lista.
            newStatus: '',

            paymentsSelected: [],

            codeFine: '',

        }
    }

    

     componentDidMount() {
        let permissions = window.localStorage.getItem('permissons');
        const userType = window.localStorage.getItem('userType');
        this.setState({paymentsSelected:[]});
        if(userType === 'ANALISTA') { 
            permissions = JSON.parse(permissions);
            let canCreate = false;
            let canEdit = false;
            let canSee = false;
            let canExonere = false;
            let canUpdateStatus = false;
            permissions[0].penalities.forEach(element => {
                if(element.name === 'see' && element.value === true){
                    canSee = true;
                }
                if(element.name === 'create' && element.value === true){
                    canCreate = true;
                }
                if(element.name === 'update' && element.value === true){
                    canEdit = true;
                    this.userCanEdit = true;
                }
                if(element.name === 'exonere' && element.value === true){
                    canExonere = true;
                }
                if(element.name === 'status' && element.value === true){
                    canUpdateStatus = true;
                }
            });
            this.setState({canCreate:canCreate, canEdit:canEdit, canSee:canSee, canExonere: canExonere, canUpdateStatus: canUpdateStatus, loading:false});
        }else{
            this.setState({canCreate:true, canEdit:true, canSee:true, canExonere:true, canUpdateStatus:true, loading:false});
            this.userCanEdit = true;
        }
  }
  

  seeDetailWhenItemClicked = (row) => {
    this.setState({ detailPenalitie: true, penalitie: row , openMenuId: null,
        anchorEl: null});
  }
  
  renderActions = (row) => {
    const isOpen = this.state.openMenuId === row.idHeaderFine;

    return (
      <>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            this.toggleMenu(row.idHeaderFine, e.currentTarget);
          }}
          aria-controls={isOpen ? `menu-${row.idHeaderFine}` : undefined}
          aria-haspopup="true"
          aria-expanded={isOpen ? 'true' : undefined}
          title="Acciones"
          id={`button-${row.idHeaderFine}`}
        >
          <Bars3Icon className="h-5 w-5 text-emerald-900" />
        </IconButton>

        <Menu
          id={`menu-${row.idHeaderFine}`}
          anchorEl={this.state.menuAnchorEl}
          open={isOpen}
          onClose={() => this.toggleMenu(row.idHeaderFine, null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top',   horizontal: 'left' }}
          MenuListProps={{
            'aria-labelledby': `button-${row.idHeaderFine}`,
            onClick: (e) => e.stopPropagation(),
          }}
        >
          {(row.descripStatus === 'PENDIENTE POR PAGAR' ||
            row.descripStatus === 'PAGO PARCIAL' ||
            row.descripStatus === 'MOROSIDAD') && (
            <MenuItem
              onClick={() => {
                this.setState({
                    payment: true,
                    penalitie: row,
                    paymentCost: row.remainder,
                    openMenuId: null,
                    anchorEl: null
                  })
              }
                
              }
            >
              <ListItemIcon>
                <BanknotesIcon className="h-5 w-5 text-emerald-900" />
              </ListItemIcon>
              <ListItemText primary="Realizar pago" />
            </MenuItem>
          )}

          <MenuItem
            onClick={() => this.setState({ detailPenalitie: true, penalitie: row , openMenuId: null,
                anchorEl: null})}
          >
            <ListItemIcon>
              <MagnifyingGlassIcon className="h-5 w-5 text-gray-900" />
            </ListItemIcon>
            <ListItemText primary="Ver detalle" />
          </MenuItem>

          {(row.descripStatus !== 'PAGADA' && row.descripStatus !== 'LLAMADO DE ATENCIÓN') &&
            this.state.canUpdateStatus && (
              <MenuItem
                onClick={() => this.setState({ changeStatus: true, penalitie: row,openMenuId: null,
                    anchorEl: null  })}
              >
                <ListItemIcon>
                  <Cog6ToothIcon className="h-5 w-5 text-gray-900" />
                </ListItemIcon>
                <ListItemText primary="Actualizar estado" />
              </MenuItem>
            )}

            {this.state.canUpdateStatus && (
              <MenuItem
                onClick={() => this.setState({ changeData: true, penalitie: row, openMenuId: null,
                    anchorEl: null  })}
              >
                <ListItemIcon>
                  <PencilIcon className="h-5 w-5 text-gray-900" />
                </ListItemIcon>
                <ListItemText primary="Actualizar datos personales" />
              </MenuItem>
            )}

          {row.url && row.url !== '' && (
            <MenuItem onClick={() => window.open(row.url, '_blank')}>
              <ListItemIcon>
                <DocumentIcon className="h-5 w-5 text-gray-900" />
              </ListItemIcon>
              <ListItemText primary="Generar reporte" />
            </MenuItem>
          )}
        </Menu>
      </>
    );
  };

  
  

  toggleMenu = (id, anchorEl) => {
    this.setState((prev) => ({
      openMenuId: prev.openMenuId === id ? null : id,
      menuAnchorEl: anchorEl,
    }));
  };

  renderColorByValue(value){
    if(value === 'PENDIENTE POR PAGAR'){
        return(
            <span className="inline-flex items-center rounded-full bg-red-100 px-1.5 py-0.5 text-xs font-medium text-red-600 ">
                PENDIENTE POR PAGAR
            </span>
        )
    }
    if(value === 'PAGO PARCIAL'){
        return(
            <span className="inline-flex items-center rounded-full bg-yellow-100 px-1.5 py-0.5 text-xs font-medium text-yellow-600 ">
                PAGO PARCIAL
            </span>
        )
    }
    if(value === 'PAGADA'){
        return(
            <span className="inline-flex items-center rounded-full bg-green-100 px-1.5 py-0.5 text-xs font-medium text-green-600 ">
                PAGADA
            </span>
        )
    }
    if(value === 'MOROSIDAD'){
        return(
            <span className="inline-flex items-center rounded-full bg-orange-100 px-1.5 py-0.5 text-xs font-medium text-orange-600 ">
                MOROSA
            </span>
        )
    }
    if(value === 'LLAMADO DE ATENCIÓN'){
        return(
            <span className="inline-flex items-center rounded-full bg-gray-100 px-1.5 py-0.5 text-xs font-medium text-gray-600 ">
                LLAMADO DE ATENCIÓN
            </span>
        )
    }
  }


    getData = () => {
        const body = this.bodyData();
        if(body){
            this.setState({loading:true});
            getAllPenalities(body)
                .then((result) => {
                    if(result && result.status === 200) {
                        let fines = [];
                        result.data.data.forEach((item) => {
                            if(item.headerFine) {
                                item.headerFine.forEach((fine) => {
                                    fine.identificationUser = item.identification;
                                    fine.fullnameUser = item.firstName + ' ' + item.middleName;
                                    fine.firstName = item.firstName;
                                    fine.middleName = item.middleName;
                                    fine.phone = item.phone ? item.phone[0] : null
                                    fine.lastName = item.firstLastName;
                                    fine.middleLastName = item.middleLastName;
                                    fine.userEmail = item.email;
                                    fine.gender = item.gender;
                                    fine.address =  item.address;
                                    fine.isCheckbox = fine.descripStatus === 'PENDIENTE POR PAGAR' ||
                                           fine.descripStatus === 'PAGO PARCIAL' ||
                                           fine.descripStatus === 'MOROSIDAD' ? true : false;
                                    fines.push(fine);
                                });
                            }
                        });
                        // Fuera del forEach: si data viene vacía, igual hay que
                        // apagar el loader (antes quedaba colgado en ese caso).
                        fines = fines.sort((a, b) => {
                            return Date.parse(b.dateReg) - Date.parse(a.dateReg);
                        });
                        // Sincronizar la selección con los datos frescos: descartar
                        // multas que ya no están/no son pagables y actualizar saldos.
                        const paymentsSelected = refreshSelection(this.state.paymentsSelected, fines);
                        this.setState({
                            penalities: fines,
                            paymentsSelected,
                            paymentCost: this.state.paymentMultiple ? sumRemainder(paymentsSelected) : this.state.paymentCost,
                            loading: false,
                        });
                    }else{
                        toast(result);
                        this.setState({penalities:[], paymentsSelected:[], loading:false});
                    }
                }).catch((error) => {
                    this.setState({loading:false});
                    toast(error);
                })
        }
    }


    exportData = () => {
        const body = this.bodyData();
        body.isReportExcel = true;
        body.limit = this.state.limit;
        if(body){
            this.setState({loading:true});
            getAllPenalities(body)
                .then((result) => {
                   if(result && result.data) {
                        window.open(result.data.data.url);
                   }else{
                        toast(result);
                   }
                   this.setState({loading:false});
                }).catch((error) => {
                    toast(error);
                })
        }
    }

    bodyData = () => {
        const body = {}
        if(this.state.identification !== '') {
            body.identification = this.state.identification;
        }
        if(this.state.numberPlate !== '') {
            body.numberPlate = this.state.numberPlate;
        }
        if(this.state.codeFine !== '') {
            body.code = this.state.codeFine;
        }
        if(this.state.dateStart !== '') {
            body.dateStart = new Date(this.state.dateStart).toISOString();
        }
        if(this.state.dateEnd !== '') {
            body.dateEnd = new Date(this.state.dateEnd).toISOString();
        }
        if(this.state.status) {
            body.status = parseInt(this.state.status);
        }
        body.limit = parseInt(this.state.limit);
        return body;
    }

    resetSearch = () => {
        this.setState({identification:'', numberPlate:'', dateStart:'', dateEnd:'', status: -1 , limit:100});
    }

    setDateSearch = (type, value) => {
        if(type === 'start') {
            this.setState({dateStart:value.target.value});
        }else{
            this.setState({dateEnd:value.target.value});
        }
    }

    classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    setTab = (tab) => {
        const tabs = this.state.tabs.map((t)=>{
                if(t.id === tab.id){
                    t.current = true
                }else{
                    t.current = false
                }
                return t
            });
        this.setState({tabs:tabs});
    }

    clearFilters = () => {
        this.setState({
            identification:'', 
            numberPlate:'', 
            codeFine:'',
            dateStart:'', 
            dateEnd:'', 
            status: -1 , 
            limit:100,
            paymentsSelected:[]
        });
    }


    searchInput = () => {
        return (
            <div className="mt-8 bg-white rounded-lg shadow-sm ring-1 ring-gray-200">
                {/* Header del panel de filtros */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200">
                    <div className="flex items-center space-x-2">
                        <FunnelIcon className="h-5 w-5 text-gray-500" />
                        <h3 className="text-lg font-semibold text-gray-900">Filtros de Búsqueda</h3>
                    </div>
                    <button
                        onClick={() => this.setState({isFiltersOpen: !this.state.isFiltersOpen})}
                        className="flex items-center text-sm text-gray-600 hover:text-gray-900"
                    >
                        {this.state.isFiltersOpen ? 'Ocultar' : 'Mostrar'} filtros
                        {this.state.isFiltersOpen ? 
                            <ChevronUpIcon className="ml-1 h-4 w-4" /> : 
                            <ChevronDownIcon className="ml-1 h-4 w-4" />
                        }
                    </button>
                </div>
                
                {/* Contenido del panel de filtros */}
                {this.state.isFiltersOpen && (
                    <div className="p-6">
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                            <div>
                                <label htmlFor="identification" className="block text-sm font-medium text-gray-700 mb-2">
                                    Identificación
                                </label>
                                <input
                                    id="identification"
                                    value={this.state.identification}
                                    onChange={(e) => {
                                        if(this.regex(e.target.value)) {
                                            this.setState({identification:e.target.value})
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            this.getData()
                                        }
                                    }}
                                    type="text"
                                    placeholder=""
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>
                            
                            <div>
                                <label htmlFor="numberPlate" className="block text-sm font-medium text-gray-700 mb-2">
                                    Placa del Vehículo
                                </label>
                                <input
                                    id="numberPlate"
                                    value={this.state.numberPlate}
                                    onChange={(e) => {this.setState({numberPlate:e.target.value})}}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            this.getData()
                                        }
                                    }}
                                    type="text"
                                    placeholder=""
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>

                            <div>
                                <label htmlFor="numberPlate" className="block text-sm font-medium text-gray-700 mb-2">
                                    Código de la Multa
                                </label>
                                <input
                                    id="codeFine"
                                    value={this.state.codeFine}
                                    onChange={(e) => {this.setState({codeFine:e.target.value})}}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            this.getData()
                                        }
                                    }}
                                    type="text"
                                    placeholder=""
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>

                            <div>
                                <label htmlFor="dateStart" className="block text-sm font-medium text-gray-700 mb-2">
                                    <CalendarIcon className="inline h-4 w-4 mr-1" />
                                    Fecha Desde
                                </label>
                                <input
                                    id="dateStart"
                                    value={this.state.dateStart}
                                    onChange={(e) => {this.setDateSearch('start',e)}}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            this.getData()
                                        }
                                    }}
                                    type="date"
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>

                            <div>
                                <label htmlFor="dateEnd" className="block text-sm font-medium text-gray-700 mb-2">
                                    <CalendarIcon className="inline h-4 w-4 mr-1" />
                                    Fecha Hasta
                                </label>
                                <input
                                    id="dateEnd"
                                    value={this.state.dateEnd}
                                    onChange={(e) => {this.setDateSearch('end',e)}}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            this.getData()
                                        }
                                    }}
                                    type="date"
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>

                            <div>
                                <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-2">
                                    Estado de la Multa
                                </label>
                                <div className="relative">
                                    <select 
                                        value={this.state.status}
                                        id="status"
                                        onChange={(e) => {this.setState({status:e.target.value})}}
                                        className="block w-full rounded-md border-0 py-2 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                    >
                                        <option value={-1}>Todos los estados</option>
                                        <option value={0}>Pendiente por Pagar</option>
                                        {/*<option value={1}>En Pausa</option>*/}
                                        <option value={2}>En Morosidad</option>
                                        <option value={3}>Pagada</option>
                                        <option value={4}>Llamado de Atención</option>
                                        <option value={5}>Pago Parcial</option>
                                        <option value={6}>Revocada</option>
                                    </select>
                                </div>
                            </div>

                            <div>
                                <label htmlFor="limit" className="block text-sm font-medium text-gray-700 mb-2">
                                    Límite de Registros
                                </label>
                                <div className="relative">
                                    <select
                                        id="limit"
                                        onChange={(e) => {this.setState({limit:parseInt(e.target.value)})}}
                                        value={this.state.limit}
                                        className="block w-full rounded-md border-0 py-2 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                    >
                                        <option value={10}>10 registros</option>
                                        <option value={50}>50 registros</option>
                                        <option value={100}>100 registros</option>
                                        <option value={500}>500 registros</option>
                                        <option value={1000}>1000 registros</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        
                        {/* Botones de acción */}
                        <div className="mt-6 flex flex-col sm:flex-row gap-3">
                            <button
                                style={{height:40, marginTop:10}}
                                onClick={() => this.getData()}
                                type="button"
                                className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-white bg-blue-950 rounded-md shadow-sm hover:bg-blue-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-950"
                            >
                                <MagnifyingGlassIcon aria-hidden="true" className="h-4 w-4 mr-2" />
                                Buscar Multas
                            </button>
                            <button
                                style={{height:40, marginTop:10}}
                                onClick={() => this.exportData()}
                                type="button"
                                className="inline-flex items-center justify-center gap-x-1.5 px-4 py-2 text-sm font-semibold text-white bg-green-700 rounded-md shadow-sm hover:bg-green-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700"
                            >
                                <ArrowDownIcon aria-hidden="true" className="h-4 w-4" />
                                Descargar Excel
                            </button>
                            <button
                                style={{height:40, marginTop:10}}
                                onClick={() => this.clearFilters()}
                                type="button"
                                className="inline-flex items-center justify-center gap-x-1.5 px-4 py-2 text-sm font-semibold text-white bg-red-700 rounded-md shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-700"
                            >
                                Limpiar
                            </button>
                            {/*<div>
                                <label htmlFor="limit" className="block text-sm font-medium text-gray-700 mb-2">
                                    Límite de Registros para el reporte
                                </label>
                                <div className="relative">
                                    <select
                                        id="limit"
                                        onChange={(e) => {this.setState({limitReport:parseInt(e.target.value)})}}
                                        value={this.state.limitReport}
                                        className="block w-full rounded-md border-0 py-2 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                    >
                                        <option value={0}>Todos los registros</option>
                                        <option value={10}>10 registros</option>
                                        <option value={50}>50 registros</option>
                                        <option value={100}>100 registros</option>
                                        <option value={500}>500 registros</option>
                                        <option value={1000}>1000 registros</option>
                                    </select>
                                </div>
                            </div> */}
                            {
                                this.state.paymentsSelected.length > 0 && (
                                    <button
                                        onClick={() => this.paymentMultiple()}
                                        type="button"
                                        className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-white bg-blue-950 rounded-md shadow-sm hover:bg-blue-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-950"
                                    >
                                        <BanknotesIcon aria-hidden="true" className="h-4 w-4 mr-2" />
                                        Realizar pago multiple
                                    </button>
                                )   
                            }
                            
                        </div>
                    </div>
                )}
            </div>
        )
    }

    formatDate = (date) => {
        const fecha = new Date(date);
        const horas = fecha.getHours();
        const minutos = fecha.getMinutes();
        const ampm = horas >= 12 ? 'PM' : 'AM';
        const horaFormateada = horas % 12 || 12;
        return `${fecha.getDate()}-${(fecha.getMonth() + 1).toString().padStart(2, '0')}-${fecha.getFullYear()} ${horaFormateada}:${minutos.toString().padStart(2, '0')} ${ampm}`
    } 

    updateStatusCheck() {
        if (this.state.loadingForm) return;
        const newStatus = parseInt(this.state.newStatus);
        if (!Number.isFinite(newStatus)) {
            toast('Por favor selecciona el nuevo estado');
            return;
        }
        this.setState({loadingForm:true})
        penalitieStatus({
            id:this.state.penalitie.idHeaderFine,
            status:newStatus
        }).then((result) => {
            if(result && result.status === 200) {
                this.setState({loadingForm:false, changeStatus:false, penalitie:false, newStatus:''});
                this.getData();
            }else{
                this.setState({loadingForm:false});
                toast(typeof result === 'string' ? result : 'No se pudo actualizar el estado');
            }
        }).catch((error) => {
            this.setState({loadingForm:false});
            toast(error?.message || 'No se pudo actualizar el estado');
        })
    }

    paymentMultiple() {
        this.setState({paymentMultiple: true, paymentCost: sumRemainder(this.state.paymentsSelected)});
    }

    removeFromPaymentSelection = (penaltyToRemove) => {
        const newSelectedPayments = this.state.paymentsSelected.filter(
            penalty => penalty.idHeaderFine !== penaltyToRemove.idHeaderFine
        );
        const newTotal = sumRemainder(newSelectedPayments);
        
        this.setState({ 
            paymentsSelected: newSelectedPayments,
            paymentCost: newTotal
        });

        if (newSelectedPayments.length === 0) {
            this.setState({ paymentMultiple: false });
        }
    }

    soloNumeros(cadena) {
        const regex = /^[0-9]*$/;
        return regex.test(cadena);
    }

    updateStatus = () => {
        return(
            <Dialog open={this.state.changeStatus} onClose={()=>console.log('closed')} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in z-40"
                />
                <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-2xl bg-white shadow-2xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-md data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            {!this.state.loadingForm ? (
                                <div className="bg-white">
                                    {/* Header */}
                                    <div className="bg-gray-50 border-b border-gray-200 px-6 py-4">
                                        <div className="flex items-center"> 
                                            <Cog6ToothIcon className="h-6 w-6 text-gray-600 mr-3" />
                                            <h3 className="text-lg font-semibold text-gray-900">Actualizar Estado</h3>
                                        </div>
                                    </div>

                                    {/* Content */}
                                    <div className="px-6 py-6">
                                        {/* Current Status Display */}
                                        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
                                            <div className="flex items-center justify-between">
                                                <span className="text-sm font-medium text-gray-700">Estado Actual:</span>
                                                <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                                                    this.state.penalitie?.descripStatus === 'PENDIENTE POR PAGAR' ? 'bg-red-100 text-red-800' :
                                                    this.state.penalitie?.descripStatus === 'PAGO PARCIAL' ? 'bg-yellow-100 text-yellow-800' :
                                                    this.state.penalitie?.descripStatus === 'PAGADA' ? 'bg-green-100 text-green-800' :
                                                    this.state.penalitie?.descripStatus === 'MOROSA' ? 'bg-orange-100 text-orange-800' :
                                                    'bg-gray-100 text-gray-800'
                                                }`}>
                                                    {this.state.penalitie?.descripStatus}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Status Selection */}
                                        <div className="space-y-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    <span className="text-red-500">*</span> Nuevo Estado
                                                </label>
                                                <select
                                                    value={this.state.newStatus}
                                                    onChange={(e) => {this.setState({newStatus:e.target.value})}}
                                                    className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 transition-colors duration-200"
                                                >
                                                    <option value="">Seleccionar nuevo estado</option>
                                                    {/*<option value={1}>En Pausa</option>*/}
                                                    <option value={3}>Pagada</option>
                                                    {this.state.canExonere && <option value={4}>Llamado de Atención</option>}
                                                    {this.state.canExonere && <option value={6}>Revocada</option>}
                                                </select>
                                            </div>

                                            {/* Warning Message */}
                                            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                                                <div className="flex">
                                                    <div className="flex-shrink-0">
                                                        <svg className="h-5 w-5 text-amber-400" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                                                        </svg>
                                                    </div>
                                                    <div className="ml-3">
                                                        <p className="text-sm text-amber-700">
                                                            Esta acción cambiará permanentemente el estado de la multa.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="bg-gray-50 px-6 py-4 flex flex-col sm:flex-row gap-3 sm:justify-end">
                                        <button
                                            type="button"
                                            onClick={() => this.setState({changeStatus:false})}
                                            className="inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 transition-colors duration-200"
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            onClick={() => {this.updateStatusCheck()}}
                                            type="button"
                                            className="inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-white bg-blue-950 border border-transparent rounded-lg hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 transition-colors duration-200 shadow-sm"
                                        >
                                            <Cog6ToothIcon className="h-4 w-4 mr-2" />
                                            Actualizar Estado
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex flex-col items-center justify-center py-12">
                                    <ClipLoader
                                        color={'black'}
                                        loading={true}
                                        size={50}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    />
                                    <p className="mt-4 text-sm text-gray-600">Actualizando estado...</p>
                                </div>
                            )}
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        )
    }

    handleVoucherFile = (event) => {
        const file = event.target.files && event.target.files[0];
        if (!file) return;
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        const allowedExt = /\.(jpe?g|png)$/i;
        if (!allowedTypes.includes(file.type) && !allowedExt.test(file.name)) {
            toast('Solo se permiten imágenes JPG, JPEG o PNG');
            event.target.value = '';
            return;
        }
        const maxBytes = 5 * 1024 * 1024;
        if (file.size > maxBytes) {
            toast('El voucher no puede superar 5 MB');
            event.target.value = '';
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            const base64 = typeof result === 'string' ? result.split(',')[1] || '' : '';
            this.setState({ paymentVoucher: base64, paymentVoucherName: file.name });
        };
        reader.onerror = () => toast('No se pudo leer el archivo del voucher');
        reader.readAsDataURL(file);
    }

    saveDirectPayment = () => {
        if (!this.state.identificationPayment || !this.state.name || !this.state.phone) {
            toast('Identificación, nombre y teléfono son obligatorios');
            return;
        }
        if (!this.state.bank) {
            toast('Debe seleccionar el banco emisor');
            return;
        }
        if (!this.state.bankCodeReceiving) {
            toast('Debe seleccionar el banco receptor');
            return;
        }
        if (!this.state.paymentCost) {
            toast('El monto es obligatorio');
            return;
        }
        if (!this.state.paymentVoucher) {
            toast('Debe adjuntar el voucher del pago');
            return;
        }

        const idDetailFine = collectDetailIds([this.state.penalitie]);
        const datetrans = this.state.dateTrans !== ''
            ? new Date(this.state.dateTrans).toISOString()
            : new Date().toISOString();

        const body = {
            idDetailFine,
            identification: this.state.identificationPayment,
            name: this.state.name,
            phone: this.state.phone,
            bankCode: this.getBankData(0),
            bank: this.getBankData(1),
            reference: this.state.paymentRef,
            datetrans,
            amount: parseFloat(this.state.paymentCost),
            bankReceiving: this.getBankDataReceiving(),
            bankCodeReceiving: this.state.bankCodeReceiving,
            comment: this.state.paymentComment || '',
            voucher: this.state.paymentVoucher,
        };

        this.setState({ loadingForm: true });
        registerAdminPayment(body).then((result) => {
            try {
                if (result && result.status === 200) {
                    toast('Pago registrado');
                    this.resetForm();
                    this.setState({ loadingForm: false, payment: false, penalitie: null });
                    this.getData();
                } else {
                    const msg = typeof result === 'string'
                        ? result
                        : (result?.response?.data?.message || 'No se pudo registrar el pago');
                    toast(msg);
                    this.setState({ loadingForm: false });
                }
            } catch (e) {
                toast(e);
                this.setState({ loadingForm: false });
            }
        }).catch((error) => {
            toast(error);
            this.setState({ loadingForm: false });
        });
    }

    // Validaciones comunes del formulario de pago móvil. Devuelve el mensaje
    // de error o null si todo está bien. Se ejecuta ANTES de activar el
    // spinner para que un dato faltante nunca deje el modal colgado.
    validatePaymentForm() {
        const type = parseInt(this.state.paymentType);
        if (!Number.isFinite(type)) return 'Por favor selecciona el tipo de pago';
        if (!this.state.identificationPayment || !this.state.name || !this.state.phone) {
            return 'Identificación, nombre y teléfono son obligatorios';
        }
        if (!this.getBankData(0)) return 'Debe seleccionar el banco emisor';
        if (!this.getBankDataReceiving()) return 'Debe seleccionar el banco receptor';
        return null;
    }

    // Envía un pago móvil (idType 3) a api/payment/pm. `fines` es la lista de
    // multas a pagar y `amount` el total transferido. El monto se reparte
    // entre TODOS los conceptos de cada multa (antes sólo se enviaba
    // detailFine[0], dejando multas con varios conceptos en PAGO PARCIAL).
    submitMobilePayment(fines, amount, onSuccess) {
        const total = round2(amount);
        if (!(total > 0)) {
            toast('El monto es obligatorio');
            return;
        }
        // Contrato del backend: un registro por concepto con su SALDO (remainder)
        // y `amount` con el total reportado. El backend reparte el monto en orden
        // entre las multas: si no alcanza, la última queda con saldo pendiente;
        // si sobra, el excedente queda a favor en administración.
        const detailFine = buildDetailFinePayload(fines);
        if (detailFine.length === 0) {
            toast('La multa seleccionada no tiene conceptos para pagar');
            return;
        }
        const saldo = sumRemainder(fines);
        if (total > saldo) {
            toast(`El monto supera el saldo en Bs. ${round2(total - saldo).toFixed(2)}; el excedente queda a favor`);
        } else if (total < saldo) {
            toast(`Pago parcial: quedan Bs. ${round2(saldo - total).toFixed(2)} pendientes`);
        }

        const body = {
            idType: parseInt(this.state.paymentType),
            identification: this.state.identificationPayment,
            dateTrans: this.state.dateTrans !== '' ? new Date(this.state.dateTrans).toISOString() : new Date().toISOString(),
            name: this.state.name,
            phone: this.state.phone,
            bankCode: this.getBankData(0),
            bank: this.getBankData(1),
            account: this.state.account,
            reference: this.state.paymentRef,
            bankCodeReceiving: this.state.bankCodeReceiving,
            bankReceiving: this.getBankDataReceiving(),
            amount: total,
            detailFine,
        };

        this.setState({loadingForm:true});
        savePaymentMultiple(body).then((result) => {
            if (result && result.status === 200) {
                toast('Pago registrado');
                this.resetForm();
                this.setState({loadingForm:false, payment:false, paymentMultiple:false, penalitie:null, paymentsSelected:[], paymentCost:''});
                this.getData();
                if (onSuccess) onSuccess();
            } else {
                const msg = typeof result === 'string'
                    ? result
                    : (result?.data?.message || 'No se pudo registrar el pago');
                toast(msg);
                this.setState({loadingForm:false});
            }
        }).catch((error) => {
            toast(error?.response?.data?.message || error?.message || 'No se pudo registrar el pago');
            this.setState({loadingForm:false});
        });
    }

    savePayment = () => {
        if (this.state.loadingForm) return;
        if(this.state.paymentType === '' || this.state.paymentType === undefined) {
            toast('Por favor selecciona el tipo de pago')
            return
        }

        if (this.state.paymentType === '5') {
            this.saveDirectPayment();
            return;
        }

        const error = this.validatePaymentForm();
        if (error) {
            toast(error);
            return;
        }
        if (!this.state.penalitie) {
            toast('No hay una multa seleccionada');
            return;
        }
        this.submitMobilePayment([this.state.penalitie], this.state.paymentCost);
    }

    savePaymentMultiple = () => {
        if (this.state.loadingForm) return;

        if(this.state.paymentsSelected.length === 0) {
            toast('No hay multas seleccionadas para procesar')
            return
        }
        if (this.state.paymentType === '5') {
            this.saveDirectPaymentMultiple();
            return;
        }
        const error = this.validatePaymentForm();
        if (error) {
            toast(error);
            return;
        }
        // El analista puede reportar un monto distinto al total (pago parcial o
        // excedente); se reparte en orden entre las multas seleccionadas.
        this.submitMobilePayment(this.state.paymentsSelected, this.state.paymentCost);
    }

    // Pago Móvil Directo (tipo 5) de varias multas: mismo endpoint que el
    // individual (api/payment/admin/pd) con TODOS los conceptos de TODAS las
    // multas seleccionadas y el voucher obligatorio. El backend reparte el monto.
    saveDirectPaymentMultiple = () => {
        if (!this.state.identificationPayment || !this.state.name || !this.state.phone) {
            toast('Identificación, nombre y teléfono son obligatorios');
            return;
        }
        if (!this.getBankData(0)) {
            toast('Debe seleccionar el banco emisor');
            return;
        }
        if (!this.getBankDataReceiving()) {
            toast('Debe seleccionar el banco receptor');
            return;
        }
        const amount = round2(this.state.paymentCost);
        if (!(amount > 0)) {
            toast('El monto es obligatorio');
            return;
        }
        if (!this.state.paymentVoucher) {
            toast('Debe adjuntar el voucher del pago');
            return;
        }
        const idDetailFine = collectDetailIds(this.state.paymentsSelected);
        if (idDetailFine.length === 0) {
            toast('Las multas seleccionadas no tienen conceptos para pagar');
            return;
        }

        const body = {
            idDetailFine,
            identification: this.state.identificationPayment,
            name: this.state.name,
            phone: this.state.phone,
            bankCode: this.getBankData(0),
            bank: this.getBankData(1),
            reference: this.state.paymentRef,
            datetrans: this.state.dateTrans !== '' ? new Date(this.state.dateTrans).toISOString() : new Date().toISOString(),
            amount,
            bankReceiving: this.getBankDataReceiving(),
            bankCodeReceiving: this.state.bankCodeReceiving,
            comment: this.state.paymentComment || '',
            voucher: this.state.paymentVoucher,
        };

        this.setState({ loadingForm: true });
        registerAdminPayment(body).then((result) => {
            if (result && result.status === 200) {
                toast('Pago registrado');
                this.resetForm();
                this.setState({ loadingForm: false, paymentMultiple: false, paymentsSelected: [], paymentCost: '' });
                this.getData();
            } else {
                const msg = typeof result === 'string'
                    ? result
                    : (result?.response?.data?.message || result?.data?.message || 'No se pudo registrar el pago');
                toast(msg);
                this.setState({ loadingForm: false });
            }
        }).catch((error) => {
            toast(error?.response?.data?.message || error?.message || 'No se pudo registrar el pago');
            this.setState({ loadingForm: false });
        });
    }

    getBankDataReceiving() {
        if(!this.state.bankCodeReceiving){
            return null;
        }
        const bank = this.banckReceived.find((item) => item.value === this.state.bankCodeReceiving)
            || this.bankAccounts.find((item) => item.value === this.state.bankCodeReceiving);
        return bank ? bank.label : null;
    }

    resetForm() {
        this.setState({
            paymentType:'',
            paymentCost:'',
            paymentRef:'',
            paymentBank:'',
            name:'',
            identificationPayment:'',
            phone: '',
            bankCode: '',
            bank: '',
            account: '',
            dateTrans: '',
            paymentComment: '',
            paymentVoucher: '',
            paymentVoucherName: '',
            penalitie: null
        });
    }

    getBankData(type) {
        if(!this.state.bank){
            return null;
        }
        const bank = this.bankAccounts.find((item) => item.value === this.state.bank);
        if (!bank) return null;
        if(type === 0){
            return bank.value;
        }
        return bank.label;
    }

    regex = (value) => {
        if(value !== '') {
            const regex = /^\d+(\.\d*)?$/;
            if(regex.test(value) === true){
                return value
            }
            return null
        }
        return true
    }

    submitValues(data) {
        const body = {
            ...data,
            idPerson: this.state.penalitie.idPerson
        }
        // Devolver la promesa: el modal (UserFormModal) muestra su propio spinner
        // mientras dura la petición y, si el backend falla, permanece abierto
        // (no se cierra) gracias al re-throw. El loader de la lista lo maneja
        // getData() en el refresco; aquí NO se toca para que no quede colgado.
        return updateData(body).then((result)=> {
            this.setState({penalitie: null});
            this.getData();
            this.resetSearch();
            toast('Datos actualizados correctamente');
        }).catch((error)=> {
            const message = typeof error === 'string'
                ? error
                : (error && error.message) || 'Ocurrió un error al actualizar los datos. Intente nuevamente.';
            toast(message);
            throw error; // re-lanzar para que el modal no se cierre
        });
    }

    renderMovilPayment(){
        return(
            <div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            <span style={{color: 'red'}}>*</span> Identificación
                        </label>
                        <div className="mt-2">
                            <input
                                onChange={(e) => {
                                    if(this.regex(e.target.value)) {
                                        this.setState({identificationPayment:e.target.value})}
                                    }
                                }
                                value={this.state.identificationPayment}
                                type="text"
                                placeholder=""
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                        </div>
                    </dd>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                        <span style={{color: 'red'}}>*</span> Nombre Completo
                        </label>
                        <div className="mt-2">
                            <input
                                onChange={(e) => {this.setState({name:e.target.value})}}
                                value={this.state.name}
                                type="text"
                                placeholder=""
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                        </div>
                    </dd>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            <span style={{color: 'red'}}>*</span> Número Telefónico
                        </label>
                        <div className="mt-2">
                            <input
                                onChange={(e) => {
                                    if(this.regex(e.target.value)) {
                                        this.setState({phone:e.target.value})
                                    }
                                    
                                }}
                                value={this.state.phone}
                                type="text"
                                placeholder=""
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                        </div>
                    </dd>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            <span style={{color: 'red'}}>*</span> Banco
                        </label>
                        <div className="mt-2">
                            <select 
                                value={this.state.bank}
                                onChange={(e) => {this.setState({bank:e.target.value})}}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            >
                                <option value="">SELECCIONAR</option>
                                    {
                                        this.bankAccounts.map((item) => {
                                            return(<option key={item.value} value={item.value}>{item.label}</option>)
                                        })
                                    }
                            </select>
                        </div>
                    </dd>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            Número de Referencia
                        </label>
                        <div className="mt-2">
                            <input
                                onChange={(e) => {
                                        if(this.regex(e.target.value)) {
                                            this.setState({paymentRef:e.target.value})}
                                        }
                                    }
                                value={this.state.paymentRef}
                                type="text"
                                placeholder=""
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                        </div>
                    </dd>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <div>
                            <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                <span style={{color: 'red'}}>*</span> Monto
                            </label>
                            <div className="mt-2">
                                <input
                                    onChange={(e) => {
                                        if(this.regex(e.target.value)) {
                                            this.setState({paymentCost:e.target.value})}
                                        }
                                    }
                                    value={this.state.paymentCost}
                                    title={this.state.paymentMultiple ? 'Monto reportado. Si es menor al total, la última multa queda con saldo pendiente; si es mayor, el excedente queda a favor.' : undefined}
                                    type="text"
                                    placeholder=""
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                />
                            </div>
                        </div>
                    </dd>
                </div>
                <div>
                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                        Fecha de pago
                    </label>
                    <div className="mt-2">
                        <input
                            value={this.state.dateTrans}
                            onChange={(e) => {this.setState({dateTrans :e.target.value})}}
                            max={new Date().toISOString().slice(0, 10)}
                            type="date"
                            placeholder=""
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                        />
                    </div>
                </div>
                {this.state.paymentType === "5" && (this.state.payment || this.state.paymentMultiple) && (
                    <>
                        <div className="mt-4">
                            <label className="block text-sm/6 font-medium text-gray-900">
                                Comentario
                            </label>
                            <div className="mt-2">
                                <textarea
                                    value={this.state.paymentComment}
                                    onChange={(e) => this.setState({paymentComment: e.target.value})}
                                    rows={3}
                                    placeholder="Comentario del pago (opcional)"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                />
                            </div>
                        </div>
                        <div className="mt-4">
                            <label className="block text-sm/6 font-medium text-gray-900">
                                <span style={{color:'red'}}>*</span> Voucher (imagen JPG, JPEG o PNG, máx. 5 MB)
                            </label>
                            <div className="mt-2 flex items-center gap-3">
                                <input
                                    type="file"
                                    accept="image/jpeg,image/jpg,image/png,.jpg,.jpeg,.png"
                                    onChange={this.handleVoucherFile}
                                    className="block w-full text-sm text-gray-900 file:mr-4 file:py-1.5 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-900 hover:file:bg-blue-100"
                                />
                            </div>
                            {this.state.paymentVoucher && (
                                <div className="mt-3 flex items-start gap-3">
                                    <img
                                        src={`data:image/*;base64,${this.state.paymentVoucher}`}
                                        alt="Previsualización del voucher"
                                        className="max-h-40 rounded border border-gray-300"
                                    />
                                    <div className="flex-1 text-xs text-gray-600 break-all">
                                        <p className="font-medium">{this.state.paymentVoucherName}</p>
                                        <button
                                            type="button"
                                            onClick={() => this.setState({paymentVoucher:'', paymentVoucherName:''})}
                                            className="mt-1 text-red-600 hover:underline"
                                        >
                                            Quitar voucher
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        )
    }


    renderTransactionsPayment() {
        return(
            <div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            <span style={{color: 'red'}}>*</span> Identificación 
                        </label>
                        <div className="mt-2">
                            <input
                                style={{placeholder:{color:'red'}}}
                                onChange={(e) => {
                                    if(this.regex(e.target.value)) {
                                        this.setState({identificationPayment:e.target.value})}
                                    }
                                }
                                value={this.state.identificationPayment}
                                type="text"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                        </div>
                    </dd>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            <span style={{color: 'red'}}>*</span> Nombre Completo
                        </label>
                        <div className="mt-2">
                            <input
                                onChange={(e) => {this.setState({name:e.target.value})}}
                                value={this.state.name}
                                type="text"
                                placeholder=""
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                        </div>
                    </dd>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            <span style={{color: 'red'}}>*</span> Banco
                        </label>
                        <div className="mt-2">
                            <select 
                                value={this.state.bank}
                                onChange={(e) => {this.setState({bank:e.target.value})}}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            >
                                <option value="">SELECCIONAR</option>
                                    {
                                        this.bankAccounts.map((item) => {
                                            return(<option key={item.value} value={item.value}>{item.label}</option>)
                                        })
                                    }
                            </select>
                        </div>
                    </dd>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <div>
                            <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                Número de cuenta
                            </label>
                            <div className="mt-2">
                                <input
                                    onChange={(e) => {
                                        if(this.regex(e.target.value)) {
                                            this.setState({account:e.target.value})}
                                        }
                                    }
                                    value={this.state.account}
                                    type="text"
                                    placeholder=""
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                />
                            </div>
                        </div>
                    </dd>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            <span style={{color: 'red'}}>*</span> Número de referencia
                        </label>
                        <div className="mt-2">
                            <input
                                onChange={(e) => {
                                        if(this.regex(e.target.value)) {
                                            this.setState({paymentRef:e.target.value})}
                                        }
                                    }
                                value={this.state.paymentRef}
                                type="text"
                                placeholder=""
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                        </div>
                    </dd>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <div>
                            <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                <span style={{color: 'red'}}>*</span> Monto
                            </label>
                            <div className="mt-2">
                                <input
                                    onChange={(e) => {
                                        if(this.regex(e.target.value)) {
                                            this.setState({paymentCost:e.target.value})}
                                        }
                                    }
                                    value={this.state.paymentCost}
                                    title={this.state.paymentMultiple ? 'Monto reportado. Si es menor al total, la última multa queda con saldo pendiente; si es mayor, el excedente queda a favor.' : undefined}
                                    type="text"
                                    placeholder=""
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                />
                            </div>
                        </div>
                    </dd>
                </div>
                <div>
                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                        Fecha de pago
                    </label>
                    <div className="mt-2">
                        <input
                            value={this.state.dateTrans}
                            onChange={(e) => {this.setState({dateTrans :e.target.value})}}
                            max={new Date().toISOString().slice(0, 10)}
                            type="date"
                            placeholder=""
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                        />
                    </div>
                </div>
            </div>
        )
    }

    sellPointPayment(){
       return(
        <div>
        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                        <span style={{color: 'red'}}>*</span> Identificación
                    </label>
                    <div className="mt-2">
                        <input
                            onChange={(e) => {
                                if(this.regex(e.target.value)) {
                                    this.setState({identificationPayment:e.target.value})}
                                }
                            }
                            value={this.state.identificationPayment}
                            type="text"
                            placeholder=""
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                        />
                    </div>
                </dd>
        </div>
        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                        <span style={{color: 'red'}}>*</span> Nombre y Apellido
                    </label>
                    <div className="mt-2">
                        <input
                            onChange={(e) => {this.setState({name:e.target.value})}}
                            value={this.state.name}
                            type="text"
                            placeholder=""
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                        />
                    </div>
                </dd>
        </div>
        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                    Número telefónico
                </label>
                <div className="mt-2">
                    <input
                        onChange={(e) => {
                            if(this.regex(e.target.value)) {
                                this.setState({phone:e.target.value})}
                            }
                    }
                        value={this.state.phone}
                        type="text"
                        placeholder=""
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                    />
                </div>
            </dd>
        </div>
            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                        Número de referencia
                    </label>
                    <div className="mt-2">
                        <input
                            onChange={(e) => {
                                if(this.regex(e.target.value)) {
                                    this.setState({paymentRef:e.target.value})}
                                }
                            }
                            value={this.state.paymentRef}
                            type="text"
                            placeholder=""
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                        />
                    </div>
                </dd>
            </div>
            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                    <div>
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            <span style={{color: 'red'}}>*</span> Monto
                        </label>
                        <div className="mt-2">
                            <input
                                onChange={(e) => {
                                    if(this.regex(e.target.value)) {
                                        this.setState({paymentCost:e.target.value})}
                                    }
                                }
                                value={this.state.paymentCost}
                                type="text"
                                placeholder=""
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                        </div>
                    </div>
                </dd>
            </div>
    </div>
       )
    }

    payment = () => {
        return(
            <Dialog open={this.state.payment} onClose={()=>{
                this.setState({payment:false})
                this.resetForm()
            }} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in z-40"
                />
                <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-2xl bg-white shadow-2xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-2xl h-[calc(100vh-2rem)] data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 flex flex-col"
                        >
                            {!this.state.loadingForm ? (
                                <div className="bg-white flex flex-col h-full">
                                    {/* Header */}
                                    <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 flex-shrink-0">
                                        <div className="flex items-center">
                                            <BanknotesIcon className="h-6 w-6 text-gray-600 mr-3" />
                                            <h3 className="text-lg font-semibold text-gray-900">Registrar Pago</h3>
                                        </div>
                                    </div>

                                    {/* Content */}
                                    <div className="px-6 py-6 flex-1 overflow-y-auto">
                                        {/* Penalty Details */}
                                        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
                                            <h4 className="text-sm font-medium text-gray-900 mb-3">Detalles de la Multa</h4>
                                            {this.detailPenalitieData()}
                                        </div>

                                        {/* Payment Form */}
                                        <div className="space-y-6">
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        <span className="text-red-500">*</span> Tipo de Pago
                                                    </label>
                                                    <select 
                                                        value={this.state.paymentType}
                                                        onChange={(e) => {this.setState({paymentType:e.target.value})}}
                                                        className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 transition-colors duration-200"
                                                    >
                                                        <option value="">Seleccionar tipo de pago</option>
                                                        {/*<option value={2}>Transferencia Bancaria</option>*/}
                                                        <option value={3}>Pago Móvil</option>
                                                        {/*<option value={4}>Punto de Venta</option>*/}
                                                        {this.state.canUpdateStatus && <option value={5}>Pago Móvil Directo</option>}
                                                    </select>
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        <span className="text-red-500">*</span> Banco Receptor
                                                    </label>
                                                    <select 
                                                        value={this.state.bankCodeReceiving}
                                                        onChange={(e) => {this.setState({bankCodeReceiving:e.target.value})}}
                                                        className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 transition-colors duration-200"
                                                    >
                                                        <option value="">Seleccionar banco</option>
                                                        {this.banckReceived.map((item, index) => (
                                                            <option key={index} value={item.value}>{item.label}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Dynamic Payment Forms */}
                                            <div className="bg-gray-50 rounded-lg p-4">
                                                {this.state.paymentType === "2" && this.renderTransactionsPayment()}
                                                {this.state.paymentType === "3" && this.renderMovilPayment()}
                                                {this.state.paymentType === "5" && this.renderMovilPayment()}
                                                {this.state.paymentType === "4" && this.sellPointPayment()}
                                                {!this.state.paymentType && (
                                                    <div className="text-center py-8 text-gray-500">
                                                        <BanknotesIcon className="h-12 w-12 mx-auto mb-3 text-gray-300" />
                                                        <p>Selecciona un tipo de pago para continuar</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex flex-col sm:flex-row gap-3 sm:justify-end flex-shrink-0">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                this.setState({payment:false})
                                                this.resetForm()
                                            }}
                                            className="inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            onClick={() => {this.savePayment()}}
                                            type="button"
                                            className="inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-white bg-blue-950 border border-transparent rounded-lg hover:bg-blue-950 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 shadow-sm"
                                        >
                                            <BanknotesIcon className="h-4 w-4 mr-2" />
                                            Guardar Pago
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex flex-col items-center justify-center py-12">
                                    <ClipLoader
                                        color={'#2563eb'}
                                        loading={true}
                                        size={50}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    />
                                    <p className="mt-4 text-sm text-gray-600">Procesando pago...</p>
                                </div>
                            )}
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        )
    }

    paymentMultipleModal = () => {
        const totalAmount = sumRemainder(this.state.paymentsSelected);
        return(
            <Dialog open={this.state.paymentMultiple} onClose={()=>{
                this.setState({paymentMultiple:false, paymentCost:0, paymentsSelected:[]});
                this.resetForm();
            }} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in z-40"
                />
                <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-2xl bg-white shadow-2xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-3xl data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            {!this.state.loadingForm ? (
                                <div className="bg-white">
                                    {/* Header */}
                                    <div className="bg-gradient-to-r from-blue-950 to-blue-950 px-6 py-4">
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center">
                                                <BanknotesIcon className="h-6 w-6 text-white mr-3" />
                                                <h3 className="text-lg font-semibold text-white">Pago Múltiple</h3>
                                            </div>
                                            <div className="flex items-center space-x-3">
                                                <span className="bg-white/20 text-white text-sm font-medium px-3 py-1 rounded-full">
                                                    {this.state.paymentsSelected.length} multa(s)
                                                </span>
                                                <button
                                                    onClick={() => this.setState({paymentMultiple: false})}
                                                    className="text-white hover:text-gray-200 transition-colors"
                                                >
                                                    <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Content */}
                                    <div className="px-6 py-6">
                                        {/* Resumen de Multas */}
                                        <div className="mb-6">
                                            <h4 className="text-sm font-medium text-gray-900 mb-3">Multas Seleccionadas</h4>
                                            <div className="bg-gray-50 rounded-lg border border-gray-200 max-h-48 overflow-y-auto">
                                                {this.state.paymentsSelected.map((penalty, index) => (
                                                    <div key={index} className="flex items-center justify-between p-3 border-b border-gray-200 last:border-b-0 hover:bg-gray-100 transition-colors">
                                                        <div className="flex items-center space-x-3 flex-1 min-w-0">
                                                            <span className="flex-shrink-0 w-6 h-6 bg-blue-100 text-blue-800 text-xs font-medium rounded-full flex items-center justify-center">
                                                                {index + 1}
                                                            </span>
                                                            <div className="min-w-0 flex-1">
                                                                <p className="text-sm font-medium text-gray-900 truncate">
                                                                    {penalty.code}
                                                                </p>
                                                                <p className="text-xs text-gray-500 truncate">
                                                                    {penalty.fullnameUser} - {penalty.identificationUser}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center space-x-3 flex-shrink-0">
                                                            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                                                                penalty.descripStatus === 'PENDIENTE POR PAGAR' ? 'bg-red-100 text-red-800' :
                                                                penalty.descripStatus === 'PAGO PARCIAL' ? 'bg-yellow-100 text-yellow-800' :
                                                                penalty.descripStatus === 'MOROSIDAD' ? 'bg-orange-100 text-orange-800' :
                                                                'bg-gray-100 text-gray-800'
                                                            }`}>
                                                                {penalty.descripStatus}
                                                            </span>
                                                            <p className="text-sm font-semibold text-green-600 min-w-[80px] text-right">
                                                                Bs. {penalty.remainder}
                                                            </p>
                                                            <button
                                                                onClick={() => this.removeFromPaymentSelection(penalty)}
                                                                className="p-1 rounded-full hover:bg-red-100 text-red-600 hover:text-red-800 transition-colors"
                                                                title="Eliminar de la selección"
                                                            >
                                                                <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Total */}
                                        <div className="mb-6 p-4 bg-green-50 rounded-lg border border-green-200">
                                            <div className="flex items-center justify-between">
                                                <h4 className="text-lg font-medium text-green-900">Saldo total seleccionado</h4>
                                                <p className="text-2xl font-bold text-green-900">
                                                    Bs. {totalAmount.toFixed(2)}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Formulario de Pago */}
                                        <div className="space-y-4">
                                            <h4 className="text-sm font-medium text-gray-900">Información del Pago</h4>
                                            
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        <span className="text-red-500">*</span> Tipo de Pago
                                                    </label>
                                                    <select 
                                                        value={this.state.paymentType}
                                                        onChange={(e) => {this.setState({paymentType:e.target.value})}}
                                                        className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 transition-colors duration-200"
                                                    >
                                                        <option value="">Seleccionar tipo de pago</option>
                                                        <option value={3}>Pago Móvil</option>
                                                        {this.state.canUpdateStatus && <option value={5}>Pago Móvil Directo</option>}
                                                    </select>
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        <span className="text-red-500">*</span> Banco Receptor
                                                    </label>
                                                    <select 
                                                        value={this.state.bankCodeReceiving}
                                                        onChange={(e) => {this.setState({bankCodeReceiving:e.target.value})}}
                                                        className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 transition-colors duration-200"
                                                    >
                                                        <option value="">Seleccionar banco</option>
                                                        {this.banckReceived.map((item, index) => (
                                                            <option key={index} value={item.value}>{item.label}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Campos específicos del tipo de pago */}
                                            <div className="bg-gray-50 rounded-lg p-4">
                                                {this.state.paymentType === "3" && this.renderMovilPayment()}
                                                {this.state.paymentType === "5" && this.renderMovilPayment()}
                                                {!this.state.paymentType && (
                                                    <div className="text-center py-6 text-gray-500">
                                                        <BanknotesIcon className="h-10 w-10 mx-auto mb-2 text-gray-300" />
                                                        <p className="text-sm">Selecciona un tipo de pago para continuar</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex flex-col sm:flex-row gap-3 sm:justify-end">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                this.setState({paymentMultiple:false})
                                                this.resetForm()
                                            }}
                                            className="inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            onClick={() => {this.savePaymentMultiple()}}
                                            type="button"
                                            className="inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-white bg-blue-950 border border-transparent rounded-lg hover:bg-blue-950 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 shadow-sm"
                                        >
                                            <BanknotesIcon className="h-4 w-4 mr-2" />
                                            Procesar Pagos
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex flex-col items-center justify-center py-12">
                                    <ClipLoader
                                        color={'#2563eb'}
                                        loading={true}
                                        size={50}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    />
                                    <p className="mt-4 text-sm text-gray-600">Procesando pagos múltiples...</p>
                                </div>
                            )}
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        )
    }

    detailProfile = () => {
        return(
            <div className="space-y-4 pt-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600 mb-1">Nombre Completo</p>
                        <p className="font-semibold text-gray-900">
                            {this.state.penalitie?.fullnameUser || 'No aplica'}
                        </p>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600 mb-1">Identificación</p>
                        <p className="font-semibold text-gray-900">
                            {this.state.penalitie?.identificationUser || 'No aplica'}
                        </p>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600 mb-1">Placa del Vehículo</p>
                        <p className="font-semibold text-gray-900">
                            {this.state.penalitie?.numberPlate || 'No requiere'}
                        </p>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600 mb-1">Marca</p>
                        <p className="font-semibold text-gray-900">
                            {this.state.penalitie?.brand || 'No requiere'}
                        </p>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600 mb-1">Modelo</p>
                        <p className="font-semibold text-gray-900">
                            {this.state.penalitie?.model || 'No requiere'}
                        </p>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600 mb-1">Correo</p>
                        <p className="font-semibold text-gray-900">
                            {this.state.penalitie?.userEmail || this.state.penalitie?.email || 'No tiene'}
                        </p>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600 mb-1">Teléfono</p>
                        <p className="font-semibold text-gray-900">
                            {this.state.penalitie?.phone || 'No tiene'}
                        </p>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg md:col-span-2">
                        <p className="text-sm text-gray-600 mb-1">Placa Grúa</p>
                        <p className="font-semibold text-gray-900">
                            {this.state.penalitie?.towTruckNumberPlate || 'No requiere'}
                        </p>
                    </div>
                </div>
            </div>
        )
    }

    detailFine = () => {
        return(
            <div className="space-y-6 pt-4">
                {/* Basic Fine Information */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                        <p className="text-sm text-blue-600 mb-1">Número de Multa</p>
                        <p className="font-semibold text-blue-900">
                            {this.state.penalitie?.code}
                        </p>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600 mb-1">Fecha</p>
                        <p className="font-semibold text-gray-900">
                            {this.formatDate(this.state.penalitie?.dateReg)}
                        </p>
                    </div>
                    <div className="bg-green-50 p-3 rounded-lg border border-green-200">
                        <p className="text-sm text-green-600 mb-1">Monto Total</p>
                        <p className="font-semibold text-green-900 text-lg">
                            Bs. {this.state.penalitie?.totalBS}
                        </p>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600 mb-1">Cédula del Oficial</p>
                        <p className="font-semibold text-gray-900">
                            {this.state.penalitie?.officialIdentification}
                        </p>
                    </div>
                </div>

                {/* Official Information */}
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                    <p className="text-sm text-blue-600 mb-2">Oficial Responsable</p>
                    <p className="font-semibold text-blue-900">
                        {this.state.penalitie?.officialFirstName + ' ' + this.state.penalitie?.officialFirstLastName}
                    </p>
                </div>

                {/* Description */}
                <div className="bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm font-medium text-gray-700 mb-3">Descripción</p>
                    <p className="text-gray-900 text-justify leading-relaxed">
                        {this.state.penalitie?.comment}
                    </p>
                </div>

                {/* Concepts */}
                <div className="bg-amber-50 p-4 rounded-lg border border-amber-200">
                    <p className="text-sm font-medium text-amber-700 mb-3">Conceptos de la Multa</p>
                    <div className="space-y-3">
                        {this.state.penalitie?.detailFine?.map((item, index) => (
                            <div key={index} className="bg-white p-3 rounded-lg border border-amber-200">
                                <p className="font-medium text-gray-900 mb-1">• {item.concept}</p>
                                <p className="text-sm text-amber-700">
                                    Valor: <span className="font-semibold">{item.valueFine}</span>
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Image */}
                <div className="bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm font-medium text-gray-700 mb-3">Evidencia Fotográfica</p>
                    {this.state.penalitie?.image?.length > 0 ? (
                        <div className="flex justify-center">
                            <img 
                                src={this.state.penalitie?.image[0].url} 
                                className="h-64 w-64 object-cover rounded-lg border border-gray-300 shadow-sm" 
                                alt='Foto de la infracción'
                            />
                        </div>
                    ) : (
                        <div className="text-center py-8 text-gray-500">
                            <svg className="h-12 w-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            <p>No posee evidencia fotográfica</p>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    detailPayment = () => {
        if(this.state.penalitie?.detailFine?.[0]?.paymentDetail){
            return(
                <div className="space-y-4 pt-4">
                    <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                        <div className="flex items-center mb-3">
                            <BanknotesIcon className="h-5 w-5 text-green-600 mr-2" />
                            <p className="text-sm font-medium text-green-700">Historial de Pagos</p>
                        </div>
                        <div className="space-y-3">
                            {this.state.penalitie?.detailFine?.[0]?.paymentDetail?.map((item, index) => (
                                <div key={index} className="bg-white p-4 rounded-lg border border-green-200 shadow-sm">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Fecha:</span>
                                            <span className="font-semibold text-gray-900">
                                                {this.formatDate(item?.dateReg)}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Monto:</span>
                                            <span className="font-semibold text-green-700 text-lg">
                                                Bs. {item?.originalAmount}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Tipo de Pago:</span>
                                            <span className="font-semibold text-gray-900">
                                                {item?.paymentTypeDescrip}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Banco:</span>
                                            <span className="font-semibold text-gray-900">
                                                {item?.bank}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Banco Receptor:</span>
                                            <span className="font-semibold text-gray-900">
                                                {item.bankReceiving ? item.bankReceiving : 'No aplica'}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Referencia:</span>
                                            <span className="font-semibold text-gray-900">
                                                {item.reference}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Procesado en:</span>
                                            <span className="font-semibold text-gray-900">
                                                {item?.paymentFromDescrip}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Usuario:</span>
                                            <span className="font-semibold text-gray-900">
                                                {item?.userName}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Titular del pago:</span>
                                            <span className="font-semibold text-gray-900">
                                                {item?.name}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Identificación:</span>
                                            <span className="font-semibold text-gray-900">
                                                {item?.identification}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )
        } else {
            return(
                <div className="pt-4">
                    <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
                        <BanknotesIcon className="h-12 w-12 mx-auto mb-4 text-gray-300" />
                        <p className="text-gray-600 text-lg font-medium mb-2">Sin Pagos Registrados</p>
                        <p className="text-gray-500 text-sm">
                            No existen pagos registrados para esta multa.
                        </p>
                    </div>
                </div>                   
            )
        }
    }

    detailPenalitieData = () => {
        return(
            <div>
                {/* Tabs adaptativos - funcionan igual en móvil y desktop */}
                <div className="border-b border-gray-200 bg-gray-50 rounded-t-lg">
                    <nav aria-label="Tabs" className="flex overflow-x-auto">
                        {this.state.tabs.map((tab) => (
                            <button
                                onClick={()=>this.setTab(tab)}
                                key={tab.name}
                                aria-current={tab.current ? 'page' : undefined}
                                className={this.classNames(
                                tab.current
                                    ? 'border-indigo-500 text-indigo-600 bg-white shadow-sm'
                                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 hover:bg-gray-100',
                                'flex-shrink-0 border-b-2 px-3 py-2 sm:px-4 sm:py-3 text-center text-xs sm:text-sm font-medium rounded-t-lg transition-colors duration-200 whitespace-nowrap',
                                )}
                            >
                                <span className="hidden sm:inline">{tab.name}</span>
                                <span className="sm:hidden">
                                    {tab.id === 0 ? 'Persona' : 
                                     tab.id === 1 ? 'Multa' : 'Pago'}
                                </span>
                            </button>
                        ))}
                    </nav>
                </div>
                
                {/* Contenido de las tabs */}
                <div className="bg-white rounded-b-lg">
                    {
                        this.state.tabs[0].current ?
                            <div>
                                {this.detailProfile()}
                            </div>
                        :
                        null
                    }
                    {
                        this.state.tabs[1].current ?
                            <div>
                                {this.detailFine()}
                            </div>
                        :
                        null
                    }
                    {
                        this.state.tabs[2].current ?
                            <div>
                                {this.detailPayment()}
                            </div>
                        :
                        null
                    }
                </div>             
            </div>
        )
    }

    detailPenalitie = () => {
        return(
            <Dialog open={this.state.detailPenalitie} onClose={()=>{
                this.setState({detailPenalitie:false})
            }} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in z-40"
                />
                <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-2xl bg-white shadow-2xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-2xl h-[calc(100vh-2rem)] data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 flex flex-col"
                        >
                            <div className="bg-white flex flex-col h-full">
                                {/* Header */}
                                <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 flex-shrink-0">
                                    <div className="flex items-center">
                                        <MagnifyingGlassIcon className="h-6 w-6 text-gray-600 mr-3" />
                                        <h3 className="text-lg font-semibold text-gray-900">Detalles de la Multa</h3>
                                        <span className={`ml-auto inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                                            this.state.penalitie?.descripStatus === 'PENDIENTE POR PAGAR' ? 'bg-red-100 text-red-800' :
                                            this.state.penalitie?.descripStatus === 'PAGO PARCIAL' ? 'bg-yellow-100 text-yellow-800' :
                                            this.state.penalitie?.descripStatus === 'PAGADA' ? 'bg-green-100 text-green-800' :
                                            this.state.penalitie?.descripStatus === 'MOROSA' ? 'bg-orange-100 text-orange-800' :
                                            'bg-gray-100 text-gray-800'
                                        }`}>
                                            {this.state.penalitie?.descripStatus}
                                        </span>
                                    </div>
                                </div>

                                {/* Content */}
                                <div className="px-6 py-6 flex-1 overflow-y-auto">
                                    {this.detailPenalitieData()}
                                </div>

                                {/* Footer */}
                                <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex justify-end flex-shrink-0">
                                    <button
                                        type="button"
                                        onClick={() => this.setState({detailPenalitie:false})}
                                        className="inline-flex justify-center items-center px-6 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200 shadow-sm"
                                    >
                                        <svg className="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                        </svg>
                                        Volver
                                    </button>
                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        )
    }

    renderList = () => {
        return (
        <div className="max-w-7xl mx-auto px-4">
            <div className="py-6">
                {this.props.withoutNav ? null : <Breadcrumb pages={this.BreadcrumbPages}/>}
                
                <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Lista de Multas</h2>
                    <p className="text-gray-600">Consulta y gestiona las multas del sistema</p>
                </div>

                {this.props.defaultFilter === false ? null : this.searchInput()}
                
                {/* Loading State */}
                {this.state.loading && (
                    <div className="text-center py-12">
                        <ClipLoader
                            color={'#1e40af'}
                            loading={true}
                            size={50}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                        <p className="mt-2 text-sm text-gray-600">Cargando multas...</p>
                    </div>
                )}

                {/* Results Table */}
                {!this.state.loading && (
                    <div className="mt-8 bg-white rounded-lg shadow-sm ring-1 ring-gray-200 overflow-hidden">
                        <div className="px-6 py-4 border-b border-gray-200">
                            <h3 className="text-lg font-semibold text-gray-900">Resultados</h3>
                            <p className="text-sm text-gray-600">
                                {this.state.penalities.length} multa(s) encontrada(s)
                            </p>
                        </div>
                        <div className="w-full">
                            <ResponsiveTable 
                                data={this.state.penalities} 
                                columns={this.columns}
                                selectedRows={this.state.paymentsSelected}
                                onRowSelectionChange={(selectedRows) => {
                                    this.setState({paymentsSelected: selectedRows})
                                }} 
                                withCheckbox={true}
                                onRowClick={(row) => this.seeDetailWhenItemClicked(row)}
                                renderActions={(row) => this.renderActions(row)}
                            />
                        </div>
                    </div>
                )}
            </div>
            {this.detailPenalitie()}
            {this.updateStatus()}
            {this.payment()}
            {this.paymentMultipleModal()}
            {
                this.state.changeData ? 
                <UserFormModal 
                    open={this.state.changeData} 
                    onClose={()=>{this.setState({changeData:false, penalitie:null})}}
                    onSubmit={(data)=> this.submitValues(data)}
                    initialValues={this.state.penalitie}
                />
                :
                null
            }
            {/* The toast */}
            <ToastContainer position="top-center" hideProgressBar={true}/>
        </div>
        )
    }

    render() {
        if(this.state.canSee) {
            return this.renderList();  
        }else{
            return(<NoAccesComponent/>)
        }
    }
}

export default PenalitiesList;